// Mock data for Mid Atlantic Business Management Inc. website
// All content is editable and can later be wired to a backend.

export const company = {
  name: "Mid Atlantic Business Management Inc.",
  shortName: "Midatlantic B2B",
  tagline: "Outsource your Call Centre Needs!",
  phone: "+1 276-622-6222",
  phoneRaw: "12766226222",
  email: "contact@midatlantic-bps.com",
  salesEmail: "andy.gawai@midatlantic-bps.com",
  addressUS: "Kohima STPI, Directorate of Information Technology & Communication, Thizama Road, Kohima, Nagaland - 797001, India",
  addressRaleigh: "8045 Arco Corporate Drive STE 130, Raleigh, NC 27617 USA",
  addressIndia: "711, 7th floor, Stellar Spaces, Kharadi, Pune, MH 411014 India",
  phoneIndia: "+91 20-35899759",
  hours: "Open today 09:00 am – 05:00 pm",
  social: {
    facebook: "https://www.facebook.com/112199248054205",
    instagram: "https://www.instagram.com/midatlantic_b2b/",
    linkedin: "https://www.linkedin.com/company/midatlantic-business-management/",
    x: "https://www.x.com/MidatlanticBPS",
  },
};

export const images = {
  heroCallCenter: "https://images.unsplash.com/photo-1766066014237-00645c74e9c6",
  ccMan: "https://images.unsplash.com/photo-1712159018726-4564d92f3ec2",
  ccTeamBg: "https://images.unsplash.com/photo-1603714228681-b399854b8f80",
  ccTwoWomen: "https://images.unsplash.com/photo-1626863905121-3b0c0ed7b94c",
  ccFloor: "https://images.unsplash.com/photo-1560264280-88b68371db39",
  medReception: "https://images.unsplash.com/photo-1606318313647-137d1f3b4d3c",
  medReception2: "https://images.unsplash.com/photo-1758691462651-611d730c5272",
  hospitalStaff: "https://images.unsplash.com/photo-1516841273335-e39b37888115",
  doctor: "https://images.unsplash.com/photo-1631217868264-e5b90bb7e133",
  insuranceClaims: "https://images.unsplash.com/photo-1637763723578-79a4ca9225f7",
  handshake: "https://images.unsplash.com/photo-1759310610325-2c7cb621e5e3",
  handshake2: "https://images.unsplash.com/photo-1758518730384-be3d205838e8",
  salesTeam: "https://images.unsplash.com/photo-1758691736097-7f735ac5f118",
  salesTeam2: "https://images.unsplash.com/photo-1758691736433-4078b93abd72",
  corporateTeam: "https://images.unsplash.com/photo-1600880292089-90a7e086ee0c",
  legal: "https://images.unsplash.com/photo-1589994965851-a8f479c573a9",
  legal2: "https://images.unsplash.com/photo-1587740896339-96a76170508d",
  contractor: "https://images.unsplash.com/photo-1587582423116-ec07293f0395",
  contractor2: "https://images.unsplash.com/photo-1589939705384-5185137a7f0f",
  finance: "https://images.unsplash.com/photo-1554224155-6726b3ff858f",
};

export const nav = [
  { label: "What We Do?", to: "/what-we-do" },
  {
    label: "Healthcare Call Center",
    children: [
      { label: "For Insurance Companies", to: "/for-insurance-companies" },
      { label: "For Doctors", to: "/for-doctors" },
      { label: "For Hospitals", to: "/for-hospitals" },
      { label: "For Orthodontists", to: "/for-orthodontists" },
    ],
  },
  {
    label: "Other Call Center",
    children: [
      { label: "For Attorneys", to: "/for-attorneys" },
      { label: "For Contractors", to: "/for-contractors" },
      { label: "Debt Collection Services", to: "/debt-collection-services" },
    ],
  },
  {
    label: "B2B Sales",
    children: [
      { label: "Leads on Demand", to: "/leads-on-demand" },
      { label: "B2B Sales Meetings", to: "/b2b-sales-meetings" },
    ],
  },
  { label: "About", to: "/about" },
  { label: "HIPAA", to: "/hipaa" },
  { label: "Blog", to: "/blog" },
  { label: "Contact", to: "/contact" },
  { label: "Jobs", to: "/jobs" },
];

export const stats = [
  { value: "160", suffix: "hrs", label: "Per Agent / Month" },
  { value: "65", suffix: "%", label: "Average Cost Savings" },
  { value: "13,800", suffix: "+", label: "Conversations / Month" },
  { value: "24/7", suffix: "", label: "Support Availability" },
];

export const homeServices = [
  {
    title: "Healthcare Call Center",
    desc: "HIPAA-compliant answering services for hospitals, doctors, orthodontists and insurance claims teams.",
    to: "/for-hospitals",
    image: images.medReception,
    icon: "HeartPulse",
  },
  {
    title: "Insurance Claims Management",
    desc: "End-to-end claims cycle management with greater accuracy, fraud detection and faster settlements.",
    to: "/for-insurance-companies",
    image: images.insuranceClaims,
    icon: "ShieldCheck",
  },
  {
    title: "Debt Collection & Recovery",
    desc: "Compliant, empathetic and effective debt recovery that protects your brand and improves cash flow.",
    to: "/debt-collection-services",
    image: images.finance,
    icon: "Wallet",
  },
  {
    title: "B2B Lead Generation",
    desc: "Omni-channel demand generation, appointment setting and qualified leads to keep your funnel full.",
    to: "/leads-on-demand",
    image: images.salesTeam,
    icon: "Target",
  },
  {
    title: "Legal Answering Service",
    desc: "Never miss a client. 24/7 intake and answering support built for attorneys and law firms.",
    to: "/for-attorneys",
    image: images.legal,
    icon: "Scale",
  },
  {
    title: "Contractor Support",
    desc: "Live answering and scheduling so contractors can win more jobs while staying on-site.",
    to: "/for-contractors",
    image: images.contractor,
    icon: "HardHat",
  },
];

export const pricing = [
  {
    name: "Full-Time Dedicated",
    price: "$1650",
    period: "/ month per agent",
    highlight: false,
    features: [
      "Dedicated employee (160 hours/month)",
      "Billed monthly, scale anytime",
      "Half-resource option (80 hrs/month)",
      "30-day money-back guarantee",
    ],
    note: "Billed monthly",
  },
  {
    name: "Annual Pre-Pay",
    price: "$800",
    period: "/ month per agent",
    highlight: true,
    features: [
      "For teams of 10 or more employees",
      "Best value \u2014 lowest per-agent rate",
      "Dedicated employees (160 hours/month)",
      "30-day money-back guarantee",
    ],
    note: "Annual pre-pay (10+ agents)",
  },
  {
    name: "Project Pricing",
    price: "Custom",
    period: "per project",
    highlight: false,
    features: [
      "Cost assessed to your needs",
      "Ideal for defined scopes",
      "Milestone-based delivery",
      "Dedicated project manager",
    ],
    note: "Tailored quote",
  },
];

export const testimonials = [
  {
    quote:
      "Midatlantic transformed our after-hours coverage. Every patient call is answered professionally and our front desk finally has room to breathe.",
    name: "Dr. Karen Mitchell",
    role: "Practice Owner, Family Health Clinic",
  },
  {
    quote:
      "Their claims team cut our processing costs dramatically while improving accuracy. Settlements are faster and our customers are happier.",
    name: "Raymond Cole",
    role: "Operations Director, Insurance Provider",
  },
  {
    quote:
      "The B2B appointment setting program filled our sales calendar with genuinely qualified meetings. A real extension of our team.",
    name: "Priya Nair",
    role: "VP Sales, SaaS Company",
  },
];

export const trustBadges = [
  "UpCity Top Call Center",
  "HIPAA Compliant",
  "30-Day Money-Back Guarantee",
  "North Carolina's Best",
];

export const whyChoose = [
  {
    title: "Lower Labor Costs",
    desc: "Reduce operational costs by up to 65% per year with skilled, dedicated offshore and onshore teams.",
    icon: "TrendingDown",
  },
  {
    title: "Scalable & Flexible",
    desc: "Ramp resources up or down as your volume changes — full-time, part-time, hourly or per project.",
    icon: "Layers",
  },
  {
    title: "Quality Assured",
    desc: "Rigorous QA, call monitoring and reporting tools give you full transparency into performance.",
    icon: "BadgeCheck",
  },
  {
    title: "HIPAA Compliant",
    desc: "100% compliance across healthcare programs, staff and tools to keep patient data secure.",
    icon: "ShieldCheck",
  },
  {
    title: "24/7 Availability",
    desc: "Round-the-clock coverage so no call is ever missed, mishandled or left unanswered.",
    icon: "Clock",
  },
  {
    title: "Risk-Free Trial",
    desc: "Give us 30 days. If you are not delighted, our money-back guarantee has you covered.",
    icon: "Handshake",
  },
];

export const aboutValues = [
  { title: "Integrity", desc: "We operate transparently and treat your customers as our own." },
  { title: "Excellence", desc: "We exceed quality standards for business ethics and service delivery." },
  { title: "Partnership", desc: "We work as a true extension of your team, aligned to your goals." },
  { title: "Innovation", desc: "We continuously refine our processes and tools to zero-down errors." },
];

export const jobs = [
  {
    title: "Customer Service Representative (Voice)",
    location: "Pune, India / Remote",
    type: "Full-time",
    desc: "Handle inbound and outbound calls for healthcare and B2B campaigns with professionalism and empathy.",
  },
  {
    title: "Insurance Claims Processor",
    location: "Pune, India",
    type: "Full-time",
    desc: "Process and validate claims accurately using our claims management workflows and QA standards.",
  },
  {
    title: "B2B Appointment Setter / SDR",
    location: "Remote",
    type: "Full-time",
    desc: "Drive qualified appointments through outbound calling, email and multi-channel outreach.",
  },
  {
    title: "Debt Recovery Specialist",
    location: "Morrisville, NC / Remote",
    type: "Full-time",
    desc: "Recover outstanding balances with a compliant, empathetic and results-driven approach.",
  },
  {
    title: "Team Lead - Contact Center Operations",
    location: "Pune, India",
    type: "Full-time",
    desc: "Lead a team of agents, drive KPIs, coach for quality and ensure SLA adherence across programs.",
  },
];

export const blogPosts = [
  {
    slug: "why-outsource-call-center-2025",
    title: "Why Outsourcing Your Call Center Is Smarter in 2025",
    excerpt:
      "Rising labor costs and customer expectations are pushing businesses toward outsourced contact centers. Here is how to do it without losing control.",
    date: "June 12, 2025",
    category: "Outsourcing",
    image: images.ccFloor,
    readTime: "6 min read",
    body: [
      "For years, businesses avoided outsourced staffing fearing a lack of control, communication issues, and quality problems. Modern BPO partners have solved these objections with transparent reporting, dedicated teams, and rigorous quality assurance.",
      "Outsourcing your call center can lower labor costs by up to 65% while giving you access to skilled, experienced agents who work as a true extension of your brand. The key is choosing a partner that offers dedicated resources, clear KPIs, and a risk-free trial period.",
      "At Mid Atlantic Business Management, we intentionally built our company to conquer these objections. Give us 30 days and we will open your eyes to lower labor costs and greater revenue.",
    ],
  },
  {
    slug: "hipaa-compliant-answering-service",
    title: "What Makes an Answering Service Truly HIPAA Compliant",
    excerpt:
      "HIPAA compliance is more than a checkbox. Learn what healthcare providers should demand from a medical answering service partner.",
    date: "May 28, 2025",
    category: "Healthcare",
    image: images.medReception2,
    readTime: "5 min read",
    body: [
      "A HIPAA-compliant answering service protects patient data at every step — from how calls are captured and stored to how messages are delivered to your staff. Compliance must extend across people, processes and technology.",
      "Look for partners who train every agent on HIPAA, use secure messaging tools, maintain audit trails, and can demonstrate 100% compliance across their healthcare programs.",
      "Our hospital and doctor answering services are built HIPAA-first, so you can be assured your patients' data is 100 percent safe at all times.",
    ],
  },
  {
    slug: "reduce-insurance-claims-cost",
    title: "5 Ways Outsourcing Cuts Insurance Claims Processing Costs",
    excerpt:
      "Insurers are turning to outsourcing to improve accuracy and cut costs. Here are five proven levers that make the biggest difference.",
    date: "May 09, 2025",
    category: "Insurance",
    image: images.insuranceClaims,
    readTime: "7 min read",
    body: [
      "Insurance leaders increasingly outsource claims administration to improve efficiency. The benefits include greater accuracy in settlements, fraud detection, and dramatic reductions in operating cost.",
      "By combining evolved claims software with skilled professionals, insurers achieve faster turnaround, higher customer retention and lower overhead — often cutting operations cost by nearly 65% per year.",
      "Streamlined processes, trained specialists, data security and quick turnaround are the pillars of a high-performing outsourced claims operation.",
    ],
  },
  {
    slug: "b2b-lead-generation-that-converts",
    title: "Building a B2B Lead Engine That Actually Converts",
    excerpt:
      "Quality leads are the lifeblood of any B2B company. Learn how omni-channel demand generation keeps your pipeline full with the right prospects.",
    date: "April 22, 2025",
    category: "B2B Sales",
    image: images.salesTeam2,
    readTime: "6 min read",
    body: [
      "Quality leads are the lifeblood of any B2B company, but generating new ideas to increase leads can be a challenge. A strong lead engine drives volume while maintaining consistent quality.",
      "We combine customer contact and profiling, content syndication, inside sales support and account-based marketing to get you in front of the right decision makers at the right time.",
      "The result: a full calendar of qualified appointments, so your sales reps can focus on closing instead of prospecting.",
    ],
  },
];

// Rich content for service pages keyed by slug.
export const servicePages = {
  "for-hospitals": {
    seoTitle: "HIPAA Compliant Hospital Answering Service",
    kicker: "Ideal HIPAA compliant hospital answering service",
    title: "Answering Service for Hospitals",
    heroImage: images.hospitalStaff,
    intro:
      "Whether you are looking for something as simple as after-hours answering coverage for a specific department or a comprehensive healthcare call center solution for your entire hospital, we have the experience and expertise necessary to help you implement an impactful live answering and messaging plan that will help your facility thrive.",
    paragraphs: [
      "Hospitals are one of the most complex and important areas of our society. From long-term care and research, to the ER and more, hospitals are the backbone of our overall healthcare system. With so many employees, patients, and systems to handle, it can be difficult for hospital staff to manage competing priorities. For this reason, we have created HIPAA compliant live hospital answering service and call center solutions designed specifically for those who protect our health and well-being.",
      "By partnering with Mid Atlantic Business Management, hospitals no longer have to manage phone calls along with other day-to-day tasks. It's like having a trained team of receptionists at your service 24 hours a day, 7 days a week. We route time-sensitive calls directly to hospital personnel and handle smaller issues with a team of highly trained call agents — giving valuable time back to your internal staff.",
    ],
    featuresTitle: "Here's what you can expect from our hospital answering service:",
    features: [
      "A team of highly-trained, professional agents who put callers at ease and get them the assistance they need.",
      "Greatly increased availability for staff to give care to patients.",
      "A dedicated team who understands the ins and outs of hospital structure and operations.",
      "Full access to our call management systems and tracking tools to measure effectiveness and satisfaction.",
      "24/7 call answering – so phone calls are never mishandled or unanswered.",
      "100% HIPAA compliance across all of our hospital call center solutions, staff and tools.",
    ],
    gallery: [images.doctor, images.medReception],
    faq: [
      { q: "Is your hospital answering service HIPAA compliant?", a: "Yes. 100% HIPAA compliance is maintained across all staff, processes and tools handling protected health information." },
      { q: "Can you cover only after-hours calls?", a: "Absolutely. We offer after-hours, overflow, and full 24/7 coverage for specific departments or your entire facility." },
      { q: "How quickly can you go live?", a: "Most programs are onboarded within days. Contact us and our Client Engagement Team will respond within 24 hours." },
    ],
  },
  "for-doctors": {
    seoTitle: "HIPAA Compliant Doctor's Answering Service",
    kicker: "Does your practice need a reliable telephone receptionist?",
    title: "Doctor's Answering Service",
    heroImage: images.doctor,
    intro:
      "Mid Atlantic Business Management helps small to mid-sized practices enhance their professional image, improve customer service, manage workload and convert callers into loyal patients. With our answering services, your incoming calls will be answered immediately by one of our trained agents.",
    paragraphs: [
      "A medical answering service is more than someone who takes phone calls when your office is closed. When someone calls after hours and wants an appointment, it can be scheduled by your answering service to fill an open slot. We can also handle patient pre-registration and follow up, so patients spend less time on paperwork and more time getting care.",
      "During office hours, letting your staff offload calls frees them to focus on the people in your waiting and consultation rooms. Our nurse triage support identifies calls that need a certified nurse's expertise and routes them appropriately — all while staying fully HIPAA compliant so your patients' data is 100 percent safe.",
    ],
    featuresTitle: "What a doctor's answering service can do for you:",
    features: [
      "Appointment scheduling and reminders that fill open slots automatically.",
      "Patient pre-registration and follow up to reduce paperwork delays.",
      "Office-hours overflow coverage so staff can focus on in-person care.",
      "Answering service for nurse triage with routing to medical expertise.",
      "HIPAA-compliant confidence protecting your practice and patients.",
      "Friendly, professional agents who represent your practice with care.",
    ],
    gallery: [images.medReception, images.medReception2],
    faq: [
      { q: "Can you schedule appointments in our system?", a: "Yes, we integrate with your scheduling workflow to book, confirm and remind patients of appointments." },
      { q: "Do you offer nurse triage?", a: "We identify triage calls and route them to the appropriate medical expertise per your protocols." },
      { q: "Is patient data secure?", a: "Completely. We are HIPAA compliant across people, process and technology." },
    ],
  },
  "for-orthodontists": {
    seoTitle: "Orthodontist Answering & Scheduling Service",
    kicker: "Grow your practice with every call answered",
    title: "Answering Service for Orthodontists",
    heroImage: images.medReception2,
    intro:
      "Turn more inquiries into booked consultations. Our orthodontic answering and scheduling specialists ensure every prospective patient reaches a friendly, knowledgeable agent — day or night.",
    paragraphs: [
      "Orthodontic practices thrive on new patient starts. A missed call is a missed opportunity. Our trained agents answer promptly, capture the right information, and book consultations directly into your calendar so your front desk never has to choose between the phone and the patient in the chair.",
      "From appointment reminders that reduce no-shows to after-hours coverage and treatment inquiries, we deliver a seamless brand experience that keeps your chairs full and your patients delighted.",
    ],
    featuresTitle: "How we help orthodontic practices grow:",
    features: [
      "New patient inquiry handling and consultation booking.",
      "Appointment reminders to reduce costly no-shows.",
      "After-hours and overflow call coverage.",
      "Insurance and treatment inquiry support.",
      "Warm, on-brand patient experience on every call.",
      "HIPAA-compliant handling of all patient information.",
    ],
    gallery: [images.doctor, images.hospitalStaff],
    faq: [
      { q: "Can you reduce our no-show rate?", a: "Yes — proactive appointment reminders and confirmations significantly reduce no-shows." },
      { q: "Do you book directly into our calendar?", a: "We schedule consultations directly into your booking system in real time." },
      { q: "Can you handle insurance questions?", a: "Our agents are trained to answer common insurance and treatment questions per your guidelines." },
    ],
  },
  "for-insurance-companies": {
    seoTitle: "Insurance Claims Cycle Management Outsourcing",
    kicker: "Why should you outsource insurance claims to us?",
    title: "Insurance Claims Cycle Management",
    heroImage: images.insuranceClaims,
    intro:
      "Let Mid Atlantic Business Management handle your insurance claims to save you time and money. We help you cut down your claims operations cost with highly effective quality and faster settlements.",
    paragraphs: [
      "More and more leaders in the insurance industry are turning to outsourcing to improve the efficiency of their claims administration. Outsourcing delivers greater customer satisfaction, high-quality service despite volume fluctuations, greater accuracy in settlements, fraudulent claims management, and a reduction in operations cost of nearly 65% per year.",
      "Mid Atlantic Business Management has served leading insurers in the USA and Canada, delivering business process outsourcing for claims. We combine highly-evolved claims processing software with skilled professionals to provide prompt, proficient claims processing that helps insurers maximize customer loyalty.",
    ],
    featuresTitle: "Services we offer:",
    features: [
      "Claims FNOL — first notice of loss capture, incident reporting and correspondence tracking.",
      "Claims case management — payment tracking, authorization-based processing, reinsurance management.",
      "Claims allocation — manual and automatic allocation based on business rules and workload.",
      "Claims document management — digital repository, signatures, and portal integration.",
      "Risk management — fraud detection, alerts, and escalation to assessors.",
      "Claims validation — policy verification, fast-track determination and investigation support.",
    ],
    gallery: [images.finance, images.corporateTeam],
    faq: [
      { q: "How much can we save?", a: "Clients typically reduce claims operations cost by up to 65% per year while improving accuracy." },
      { q: "Do you help with fraud detection?", a: "Yes. We provide indicators, alerts and risk escalation as part of claims validation." },
      { q: "Is our data secure?", a: "We strictly follow data security policies to keep all shared information completely secure." },
    ],
  },
  "for-attorneys": {
    seoTitle: "Legal Answering Service for Attorneys & Law Firms",
    kicker: "Never miss a client again",
    title: "Answering Service for Attorneys",
    heroImage: images.legal,
    intro:
      "Every missed call could be a missed case. Our legal answering and intake specialists ensure prospective clients always reach a professional, empathetic agent who represents your firm with the care it deserves.",
    paragraphs: [
      "Law firms rely on responsiveness. When potential clients reach out, they expect prompt, confidential and knowledgeable service. Our trained agents handle new client intake, appointment scheduling and message delivery 24/7 so you can focus on practicing law instead of answering phones.",
      "We capture the details that matter, follow your intake scripts precisely, and route urgent matters to the right attorney immediately — giving your firm a polished, always-available front line.",
    ],
    featuresTitle: "How we support law firms:",
    features: [
      "24/7 new client intake following your custom scripts.",
      "Appointment scheduling and calendar management.",
      "Confidential, professional message handling.",
      "Urgent call routing to the right attorney.",
      "Bilingual and overflow coverage options.",
      "Detailed call reporting and tracking tools.",
    ],
    gallery: [images.legal2, images.corporateTeam],
    faq: [
      { q: "Can you follow our intake script?", a: "Yes — we follow your custom intake scripts precisely and capture all required details." },
      { q: "Do you offer 24/7 coverage?", a: "We provide round-the-clock intake and answering so no potential client is ever missed." },
      { q: "Is client information kept confidential?", a: "Confidentiality is central to our legal answering programs and staff training." },
    ],
  },
  "for-contractors": {
    seoTitle: "Answering & Scheduling Service for Contractors",
    kicker: "Win more jobs without leaving the job site",
    title: "Answering Service for Contractors",
    heroImage: images.contractor,
    intro:
      "Contractors win work by being responsive. When you're on a ladder or under a sink, our agents answer your calls, book estimates and dispatch emergencies — so you never lose a job to a missed call.",
    paragraphs: [
      "From plumbing and HVAC to general contracting and electrical, service businesses live and die by responsiveness. Our trained agents answer promptly, qualify the caller, schedule estimates and appointments, and dispatch urgent jobs according to your rules.",
      "You stay focused on the work in front of you while we keep your pipeline full and your customers informed with professional, on-brand service around the clock.",
    ],
    featuresTitle: "How we help contractors grow:",
    features: [
      "Live call answering during and after business hours.",
      "Estimate and appointment scheduling.",
      "Emergency dispatch based on your rules.",
      "Lead qualification and follow-up.",
      "Overflow coverage during busy seasons.",
      "Professional, on-brand customer experience.",
    ],
    gallery: [images.contractor2, images.ccMan],
    faq: [
      { q: "Can you dispatch emergency calls?", a: "Yes — we follow your dispatch rules to route emergencies to the right person immediately." },
      { q: "Do you schedule estimates?", a: "We book estimates and appointments directly into your calendar." },
      { q: "Can you handle seasonal spikes?", a: "Our scalable model provides overflow coverage during your busiest seasons." },
    ],
  },
  "debt-collection-services": {
    seoTitle: "Debt Collection & Debt Recovery Services",
    kicker: "Compliant, empathetic and effective",
    title: "Debt Collection & Recovery Services",
    heroImage: images.finance,
    intro:
      "Recover more of what you're owed while protecting your brand. Our debt recovery specialists combine proven, compliant processes with a respectful, customer-first approach that improves your cash flow.",
    paragraphs: [
      "Effective debt recovery is a balance of persistence and professionalism. Our specialists follow all applicable regulations while treating your customers with respect — preserving relationships and your reputation as they resolve outstanding balances.",
      "With structured workflows, skip tracing support, clear reporting and consistent follow-up, we help you improve recovery rates and reduce the cost and distraction of chasing payments in-house.",
    ],
    featuresTitle: "Our debt recovery capabilities:",
    features: [
      "First-party and third-party collection programs.",
      "Compliant, respectful outreach that protects your brand.",
      "Structured follow-up cadences and payment plans.",
      "Detailed reporting and full transparency.",
      "Multi-channel outreach — voice, email and SMS.",
      "Best fit for claims handling, answering and collections.",
    ],
    gallery: [images.ccTwoWomen, images.corporateTeam],
    faq: [
      { q: "Are your collection practices compliant?", a: "Yes. We follow all applicable regulations and prioritize respectful, brand-safe outreach." },
      { q: "What recovery rates can we expect?", a: "Results vary by portfolio; our structured cadences and follow-up consistently improve recovery." },
      { q: "Do you offer reporting?", a: "You get detailed reporting and full transparency into every account and outcome." },
    ],
  },
  "leads-on-demand": {
    seoTitle: "B2B Leads on Demand & Lead Generation",
    kicker: "As your extended team, we power-line your business operations",
    title: "Leads on Demand",
    heroImage: images.salesTeam,
    intro:
      "Quality leads are the lifeblood of any B2B company. We deliver innovative, omni-channel demand generation programs that keep your funnel full while maintaining consistent quality.",
    paragraphs: [
      "We stand out in the industry by delivering innovative programs that reflect our unique and broad multi-channel capabilities. Our approach, act and delivery framework serves clients with quality and distinction, making a measurable and attributable impact on every program we execute.",
      "From customer contact and profiling to content syndication, inside sales support and B2B data research, we get you in front of the right audience with accuracy and precision. We make over 13,800 successful conversations on average every month.",
    ],
    featuresTitle: "Our demand generation services:",
    features: [
      "Customer contact & profiling with precision targeting.",
      "Content syndication and media distribution.",
      "Inside sales support and BDR programs.",
      "B2B data research — verified, accurate contacts.",
      "Data enrichment — cleaned, de-duplicated lists.",
      "Appointment setting, sales leads and event registrations.",
    ],
    gallery: [images.salesTeam2, images.handshake],
    faq: [
      { q: "How do you ensure lead quality?", a: "We qualify rigorously and continuously refine our process to zero-down bad leads." },
      { q: "What channels do you use?", a: "Voice, email, content syndication and multi-channel outreach for maximum reach." },
      { q: "Can you provide verified data?", a: "Yes — we research and deliver current, validated B2B contacts and enrich existing lists." },
    ],
  },
  "b2b-sales-meetings": {
    seoTitle: "B2B Sales Meetings & Appointment Setting",
    kicker: "Fill your calendar with meetings that close",
    title: "B2B Sales Meetings",
    heroImage: images.handshake,
    intro:
      "Let your sales reps invest their time closing, not prospecting. Our appointment generation specialists fill your calendar with qualified meetings that convert into revenue.",
    paragraphs: [
      "Appointment generation is a crucial step in building a strong sales structure. We do the pre-work for you — nurturing leads, confirming genuine need, and adding the perfect-fit prospects to your sales calendar. If you make more conversations, you end up closing more.",
      "With account-based marketing and concentrated tele-marketing efforts backed by accurate data, we connect you directly with decision makers — clearing the obstacles between your SDRs and the prospect.",
    ],
    featuresTitle: "What you get:",
    features: [
      "Qualified appointment setting with decision makers.",
      "Account-based marketing to high-value targets.",
      "Content marketing and webinar registrations.",
      "Market qualified leads and event reminders.",
      "Direct-dial outreach that reaches real prospects.",
      "A consistently full, high-quality sales calendar.",
    ],
    gallery: [images.salesTeam, images.handshake2],
    faq: [
      { q: "Are the meetings pre-qualified?", a: "Yes — we confirm genuine need and fit before adding a meeting to your calendar." },
      { q: "Do you use ABM?", a: "We run account-based marketing to connect with high-level decision makers." },
      { q: "How many meetings can you generate?", a: "Volume depends on your market and offer; we drive consistent, quality meetings each month." },
    ],
  },
};

export const hipaaContent = {
  title: "HIPAA Compliance",
  intro:
    "Protecting patient health information is at the core of every healthcare program we run. Our people, processes and technology are built HIPAA-first so you can trust us with your most sensitive data.",
  sections: [
    {
      title: "Trained & Certified Staff",
      desc: "Every agent handling protected health information is trained on HIPAA requirements and regularly re-certified.",
    },
    {
      title: "Secure Technology",
      desc: "We use secure messaging, encrypted storage and audit trails to protect data at rest and in transit.",
    },
    {
      title: "Strict Access Controls",
      desc: "Access to PHI is limited to authorized personnel on a need-to-know basis, with full logging.",
    },
    {
      title: "Ongoing Audits",
      desc: "Regular internal audits and monitoring ensure continued compliance across all healthcare programs.",
    },
  ],
};

// Full HIPAA privacy policy document provided by the company.
export const hipaaPrivacyOfficer = {
  name: "Justin Keishing",
  phone: "+1 469-949-6226",
  email: "contact@midatlantic-bps.com",
  address: "705-14 Keystone Park Drive, Morrisville NC, 27560 USA",
};

export const hipaaPolicySections = [
  {
    num: "1.0",
    title: "Scope",
    blocks: [
      { p: "This policy outlines the responsibilities of Mid Atlantic Business Management Inc. (\u201cContractor\u201d) to safeguard the privacy and security of Protected Health Information (\u201cPHI\u201d) in compliance with the Health Insurance Portability and Accountability Act of 1996 (\u201cHIPAA\u201d), including the HIPAA Privacy Rule and Security Rule (45 CFR Parts 160 and 164), as well as the Health Information Technology for Economic and Clinical Health (HITECH) Act." },
      { p: "This policy operates in conjunction with the Business Associate Agreement (\u201cBAA\u201d) executed between Mid Atlantic Business Management Inc. and each Client." },
      { sub: "Definitions:" },
      { ul: [
        "Client: Any customer with whom Mid Atlantic Business Management Inc. has a legal Business Associate Agreement.",
        "Served Patients: Patients who receive services from or through the Contractor.",
        "Contractor: Mid Atlantic Business Management Inc.",
      ] },
    ],
  },
  {
    num: "2.0",
    title: "Scope",
    blocks: [
      { p: "This policy applies to all Clients, Served Patients, and Contractor workforce members who access PHI. The Contractor's workforce includes employees, volunteers, trainees, subcontractors, and any person under direct control of the Contractor, regardless of compensation status." },
    ],
  },
  {
    num: "3.0",
    title: "Roles and Responsibilities",
    blocks: [
      { sub: "3.1 Privacy Officer" },
      { p: "Andy Gawai, Director of Client Relations, is designated as the Privacy Officer and will:" },
      { ul: [
        "Develop and implement policies and procedures regarding the use and disclosure of PHI;",
        "Monitor compliance with HIPAA regulations and this Privacy Policy;",
        "Ensure BAAs are in place and enforced with Clients and subcontractors;",
        "Serve as the primary contact for privacy inquiries and complaints.",
      ] },
      { contact: true },
      { sub: "3.2 Workforce Training" },
      { p: "All workforce members who handle PHI must complete HIPAA training tailored to their job responsibilities. Training will be documented and retained for a minimum of six (6) years." },
      { sub: "3.3 Safeguards" },
      { p: "The Contractor will implement administrative, technical, and physical safeguards, including:" },
      { ul: [
        "Administrative: Written policies on PHI handling and disclosure;",
        "Technical: Role-based access control and audit trails for PHI systems;",
        "Physical: Secured workspaces, locked storage, and access-restricted areas.",
      ] },
    ],
  },
  {
    num: "4.0",
    title: "Complaints Process",
    blocks: [
      { p: "Individuals may file complaints related to PHI privacy:" },
      { ul: [
        "All complaints must be submitted to the Privacy Officer;",
        "The Privacy Officer will maintain documentation of all complaints and resolution steps;",
        "Complaint procedures are available upon request.",
      ] },
    ],
  },
  {
    num: "5.0",
    title: "Breach Notification",
    blocks: [
      { p: "In accordance with 45 CFR \u00a7\u00a7 164.400-414, the Contractor will notify the Client of any unauthorized access, use, or disclosure of unsecured PHI within 10 business days of discovery. Breach notifications will include:" },
      { ul: [
        "A description of the breach;",
        "Types of information involved;",
        "Steps taken to mitigate harm;",
        "Contact procedures for affected individuals.",
      ] },
    ],
  },
  {
    num: "6.0",
    title: "Disciplinary Actions",
    blocks: [
      { p: "Violations of this policy may result in disciplinary action, up to and including suspension or termination. Sanctions will align with the Contractor's internal disciplinary procedures." },
    ],
  },
  {
    num: "7.0",
    title: "Use and Disclosure of PHI",
    blocks: [
      { p: "The Contractor and its workforce will:" },
      { ul: [
        "Use and disclose PHI only as permitted under HIPAA or with valid authorization;",
        "Comply with the \u201cminimum necessary\u201d standard by limiting PHI access to only what is required;",
        "Adhere to any signed participant authorization per 45 CFR \u00a7164.508.",
      ] },
    ],
  },
  {
    num: "8.0",
    title: "Definitions and Standards",
    blocks: [
      { sub: "8.1 Use vs. Disclosure" },
      { ul: [
        "Use: Internal utilization of PHI by workforce members within their roles.",
        "Disclosure: Sharing PHI with individuals or entities outside the Contractor, unless permitted under HIPAA.",
      ] },
      { sub: "8.2 Minimum Necessary and Limited Data Sets" },
      { p: "PHI use/disclosure will be minimized. Limited Data Sets exclude the following identifiers:" },
      { ul: [
        "Names, full postal addresses, SSNs, phone numbers, email addresses;",
        "Medical record numbers, account numbers, and license numbers;",
        "IP addresses, URLs, biometric identifiers, and photographic images.",
      ] },
      { sub: "8.3 PHI Definition" },
      { p: "PHI is any health-related information that identifies or could reasonably be used to identify an individual. This includes data relating to treatment, payment, or healthcare operations for living or deceased individuals." },
    ],
  },
  {
    num: "9.0",
    title: "Non-Retaliation",
    blocks: [
      { p: "Contractor prohibits retaliation against any individual who:" },
      { ul: [
        "Files a privacy complaint;",
        "Participates in a privacy investigation;",
        "Exercises any HIPAA-related rights.",
      ] },
      { p: "No individual may be required to waive HIPAA rights as a condition of service." },
    ],
  },
  {
    num: "10.0",
    title: "Subcontractor Compliance",
    blocks: [
      { p: "Subcontractors and vendors who access PHI must:" },
      { ul: [
        "Sign a HIPAA-compliant agreement;",
        "Implement safeguards in line with this policy;",
        "Notify the Contractor of any PHI breach.",
      ] },
    ],
  },
  {
    num: "11.0",
    title: "Policy Management",
    blocks: [
      { p: "This Privacy Policy is subject to change. The Contractor may amend or revise this document at any time, and Clients will be notified of significant updates." },
    ],
  },
  {
    num: "12.0",
    title: "Contact",
    blocks: [
      { p: "Privacy Officer Contact:" },
      { contact: true },
    ],
  },
];
